// Re-export ForgotPasswordModal from route group to avoid webpack resolution issues on server
// This file acts as a bridge to import the component without going through route group parentheses
export { default } from '../../app/(auth)/login/components/ForgotPasswordModal.jsx';

